import { useMutation, useQueryClient } from '@tanstack/react-query'
import { sessionApi } from '@/entities/session'
import { queryKeys } from '@/shared/api/queryKeys'
import { toast } from '@/shared/model/toast'
import { ApiError } from '@/shared/api/client'
import type { Account, Company, CompanyRequest } from '@/shared/api/types'

export function useUpdateCompany() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: CompanyRequest) => sessionApi.updateCompany(body),
    onSuccess: (company: Company) => {
      // Компания входит в ответ /me, и в шапке показана оттуда же.
      // Правим её прямо в кэше аккаунта, иначе название в углу экрана
      // остаётся старым до перезагрузки страницы.
      queryClient.setQueryData<Account>(queryKeys.account, (prev) =>
        prev ? { ...prev, company } : prev,
      )
      toast.success('Данные компании обновлены')
    },
    onError: (error) => {
      toast.error(error instanceof ApiError ? error.message : 'Не удалось сохранить')
    },
  })
}
